import * as React from "react";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ImageWithOverlay } from "../../../../presentation/Shared/Image/ImageWithOverlay";
import { Style, StyleClass } from "../../../../presentation/Shared/Styles/CSS";
import { webkitFilterGlitchFix } from "../../../../presentation/Shared/Styles/SharedStyles";
import { UnmountAllSwals } from "../RenderSwal";

const OK = ({ Fulfill }: { Fulfill?: Function }) => {
    if (!Fulfill) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={() => {
                try {
                    Sounds.kickdrum_heavy.Play();
                    // "true" parameter seems to be required here
                    Fulfill(true);
                } finally {
                    UnmountAllSwals();
                }
            }}
            className={sharedButtonStyleClass}
        >
            <ImageWithOverlay
                options={{
                    imageLabel: `OKButton`,
                    imageWidth: 60,
                    imageHeight: 27,
                    imageUrl: "/images/icons/capsule.svg",
                    imageCSS: {
                        filter: `sepia(0.2) hue-rotate(4deg)`,
                        ...webkitFilterGlitchFix,
                    },
                }}
            >
                OK
            </ImageWithOverlay>
        </button>
    );
};

const Cancel = ({ Cancel }: { Cancel?: Function }) => {
    if (!Cancel) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={() => {
                Sounds.metal_swipe.Play();
                if (Cancel) Cancel();

                UnmountAllSwals();
            }}
            className={sharedButtonStyleClass}
            {...Style(`Cancel`, {
                color: "white",
            })}
        >
            <ImageWithOverlay
                options={{
                    imageLabel: `CancelButton`,
                    imageWidth: 79,
                    imageHeight: 27,
                    imageUrl: "/images/icons/capsule-long.svg",
                    imageCSS: {
                        filter: `sepia(0.2) hue-rotate(4deg)`,
                        ...webkitFilterGlitchFix,
                    },
                }}
            >
                Cancel
            </ImageWithOverlay>
        </button>
    );
};

const Save = ({
    onClick,
    disabled = false,
    label = "Save",
}: {
    onClick: Function;
    disabled?: boolean;
    label?: string;
}) => {
    return (
        <button
            type="button"
            disabled={disabled}
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
            className={sharedButtonStyleClass}
        >
            <ImageWithOverlay
                options={{
                    imageLabel: `SaveButton`,
                    imageWidth: 60,
                    imageHeight: 27,
                    imageUrl: "/images/icons/capsule.svg",
                    imageCSS: {
                        filter: `sepia(0.2) hue-rotate(70deg)`,
                        ...webkitFilterGlitchFix,
                    },
                }}
            >
                {label}
            </ImageWithOverlay>
        </button>
    );
};

export const SwalButtons = {
    OK,
    Cancel,
    Save,
};

const sharedButtonStyleClass = StyleClass(`sharedButtonStyle`, {
    background: "none",
    border: "none",
    outline: `none`,
    padding: "5px 8px",
    color: "black",
    fontSize: "14px",
    fontWeight: `bold`,
    ":hover": {
        fontWeight: `bold`,
        filter: `saturate(0.5) brightness(2)`,
        ...webkitFilterGlitchFix,
    },
    ":focus": {
        borderRadius: "6px",
        boxShadow: "0px 0px 7px gold",
    },
    ":disabled": {
        cursor: "not-allowed",
        filter: "grayscale(1)",
        opacity: 0.55,
    },
});
